function ErrorFallback({ message, onRetry }) {
  return (
    <div className="py-20 text-center">
      <p className="text-soft-dim mb-4">{message || 'Something went wrong.'}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-soft-ink text-soft-bg text-sm cursor-pointer"
        >
          Try again
        </button>
      )}
    </div>
  )
}

export default ErrorFallback
